"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bemTooltip = exports.GlTooltip = exports.GL_TOOLTIP_THEME = exports.GL_TOOLTIP_SIZE = exports.GL_TOOLTIP_PLACEMENT = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _bero = _interopRequireWildcard(require("bero"));

var _componentIcon = require("@adl/component-icon");

var _componentUtils = require("@adl/component-utils");

var _glPopper = require("./utils/gl-popper");

var _glPopperReference = require("./utils/gl-popper-reference");

var _glPopperManager = require("./utils/gl-popper-manager");

var _glTooltipButton = require("./gl-tooltip-button");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["className", "children", "size", "placement", "label", "boundariesElement", "theme", "closeButtonEnabled", "htmlAttrs", "trigger"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var bemTooltip = (0, _bero.default)('gl-tooltip');
exports.bemTooltip = bemTooltip;
var GL_TOOLTIP_PLACEMENT = {
  bottom: 'bottom',
  left: 'left',
  right: 'right',
  top: 'top'
};
exports.GL_TOOLTIP_PLACEMENT = GL_TOOLTIP_PLACEMENT;
var GL_TOOLTIP_SIZE = {
  small: 'small',
  large: 'large',
  regular: 'regular'
};
exports.GL_TOOLTIP_SIZE = GL_TOOLTIP_SIZE;
var GL_TOOLTIP_THEME = {
  dark: 'dark'
};
exports.GL_TOOLTIP_THEME = GL_TOOLTIP_THEME;

var GlTooltip = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(GlTooltip, _PureComponent);

  var _super = _createSuper(GlTooltip);

  function GlTooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GlTooltip);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEsc", function (event) {
      if (event.code === 'Escape' && _this.state.isOpen) {
        _this.closeTooltip(event, 'escape-key');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeTooltip", function (event) {
      var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'close-button';
      _this.state.isOpen && (0, _componentUtils.safeInvoke)(_this.props.onClose, event, eventType);

      _this.setState({
        isOpen: false
      });

      window.removeEventListener('click', _this.onClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickOutside", function (event) {
      if (_this.popperNode && !_this.popperNode.contains(event.target)) {
        _this.closeTooltip(event, 'click-outside');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.closeOthers();

      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      }, function () {
        _this.state.isOpen ? _this.props.onOpen && (0, _componentUtils.safeInvoke)(_this.props.onOpen, event) : _this.props.onClose && (0, _componentUtils.safeInvoke)(_this.props.onClose, event, 'icon');
      });

      window.addEventListener('click', _this.onClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInnerRef", function (node) {
      return _this.popperNode = node;
    });
    _this.popperNode = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }

  (0, _createClass2.default)(GlTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleEsc);
      document.addEventListener('glTooltipEvent', this.closeTooltip);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleEsc);
      document.removeEventListener('glTooltipEvent', this.closeTooltip);
    }
  }, {
    key: "closeOthers",
    value: function closeOthers() {
      // Send an event to close other tooltips before we open current instance
      // without checking if current instance is not opened we wouldn't be able to close it
      if (!this.state.isOpen) {
        // This is the only solution for IE 11, but deprecated by other modern
        // web browsers
        var _event = document.createEvent('Event');

        _event.initEvent('glTooltipEvent', true, true);

        document.dispatchEvent(_event);
      }
    }
  }, {
    key: "tooltipPlacement",
    value: function tooltipPlacement(placement) {
      switch (placement) {
        case GL_TOOLTIP_PLACEMENT.left:
          return [GL_TOOLTIP_PLACEMENT.left, GL_TOOLTIP_PLACEMENT.bottom, GL_TOOLTIP_PLACEMENT.top, GL_TOOLTIP_PLACEMENT.right];

        case GL_TOOLTIP_PLACEMENT.top:
          return [GL_TOOLTIP_PLACEMENT.top, GL_TOOLTIP_PLACEMENT.bottom, GL_TOOLTIP_PLACEMENT.left, GL_TOOLTIP_PLACEMENT.right];

        case GL_TOOLTIP_PLACEMENT.bottom:
          return [GL_TOOLTIP_PLACEMENT.bottom, GL_TOOLTIP_PLACEMENT.top, GL_TOOLTIP_PLACEMENT.right, GL_TOOLTIP_PLACEMENT.left];

        case GL_TOOLTIP_PLACEMENT.right:
          return [GL_TOOLTIP_PLACEMENT.right, GL_TOOLTIP_PLACEMENT.bottom, GL_TOOLTIP_PLACEMENT.top, GL_TOOLTIP_PLACEMENT.left];
      }

      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          _children = _this$props.children,
          size = _this$props.size,
          placement = _this$props.placement,
          label = _this$props.label,
          boundariesElement = _this$props.boundariesElement,
          theme = _this$props.theme,
          closeButtonEnabled = _this$props.closeButtonEnabled,
          htmlAttrs = _this$props.htmlAttrs,
          _this$props$trigger = _this$props.trigger,
          trigger = _this$props$trigger === void 0 ? function (_ref) {
        var ref = _ref.ref,
            toggleTooltip = _ref.toggleTooltip;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_glTooltipButton.GlTooltipButton, {
          ref: ref,
          theme: theme,
          onClick: toggleTooltip,
          label: label,
          htmlAttrs: {
            openerButton: htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.openerButton,
            openerIcon: htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.openerIcon
          }
        });
      } : _this$props$trigger,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var placementArray = this.tooltipPlacement(placement);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, (0, _componentUtils.custom)(props)), {}, {
        className: (0, _bero.join)(bemTooltip({
          withIcon: !label
        }), className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_glPopperManager.PopperManager, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_glPopperReference.PopperReference, {
            toggleTooltip: this.handleClick,
            children: trigger
          }), this.state.isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_glPopper.Popper, {
            referenceElement: undefined,
            innerRef: this.handleInnerRef,
            placement: placement,
            modifiers: {
              preventOverflow: {
                boundariesElement: boundariesElement,
                priority: placementArray,
                padding: 15
              },
              flip: {
                behavior: placementArray
              },
              offset: {
                offset: '0, 20px'
              }
            },
            children: function children(popperProps) {
              var arrowProps = popperProps.arrowProps,
                  placement = popperProps.placement,
                  style = popperProps.style,
                  ref = popperProps.ref;
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                ref: ref,
                "data-placement": placement,
                style: style,
                className: (0, _bero.join)(bemTooltip('panel', [size, theme])),
                children: [closeButtonEnabled && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({
                  type: "button",
                  className: bemTooltip('close'),
                  onClick: _this2.closeTooltip
                }, htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.closeButton), {}, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentIcon.GlIcon, {
                    name: "close",
                    iconClassName: bemTooltip('close-icon', [theme])
                  })
                })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: (0, _bero.join)(bemTooltip('inner')),
                  children: _children
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  ref: arrowProps.ref,
                  style: arrowProps.style,
                  className: (0, _bero.join)(bemTooltip('arrow', [placement, theme]))
                })]
              });
            }
          })]
        })
      }));
    }
  }]);
  return GlTooltip;
}(_react.PureComponent);

exports.GlTooltip = GlTooltip;
(0, _defineProperty2.default)(GlTooltip, "defaultProps", {
  boundariesElement: 'viewport',
  placement: GL_TOOLTIP_PLACEMENT.right,
  size: GL_TOOLTIP_SIZE.regular
});